import { CURRENCIES } from '../types';

const PRICE_ON_REQUEST_TEXT = 'Price on request';

type PriceDisplayOptions = {
  price: string | null | undefined;
  priceOnRequest: boolean;
  currency: string | null | undefined;
};

type PriceDisplayResult = {
  priceText: string;
  isValidPrice: boolean;
};

const ZERO_PRICE_VALUES = new Set(['0', '€0', '£0']);

const getPriceDisplay = ({
  price,
  priceOnRequest,
  currency,
}: PriceDisplayOptions): PriceDisplayResult => {
  if (priceOnRequest) {
    return { priceText: PRICE_ON_REQUEST_TEXT, isValidPrice: false };
  }

  if (!price || ZERO_PRICE_VALUES.has(price)) {
    return { priceText: PRICE_ON_REQUEST_TEXT, isValidPrice: false };
  }

  if (currency) {
    const symbol = currency === CURRENCIES.EUR ? '€' : '£';
    return { priceText: `${symbol}${price}`, isValidPrice: true };
  }

  return { priceText: price, isValidPrice: true };
};

export { getPriceDisplay };
